var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EmergencyCallDashboard',{ref:"dashboard",attrs:{"fetch-aggregate":_vm.fetchMain115,"live-data":_vm.live115,"refresh-timer-in-minute":_vm.refreshTimerInMinute}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }